import styled from "styled-components";
import { RefreshIcon, UsersIcon, PlayIcon } from "@8x8/oxygen-icon";
import ToggleButton from "@8x8/oxygen-toggle-button";
import Button from "@8x8/oxygen-button";

import PageTitle from "@/react/components/PageTitle";
import { COLORS } from "@/react/theme/constants";

export const Title = styled(PageTitle)`
  margin: 0 0 16px;
`;

export const InnerContainer = styled.div`
  border: 1px solid ${COLORS.tertiary};
`;

export const ContainerBody = styled.div`
  padding: 12px;
`;

export const StyledUsersIcon = styled(UsersIcon)`
  margin-right: 8px;
`;

export const ActionTitle = styled.h5`
  padding: 12px;
  border-bottom: 1px solid ${COLORS.tertiary};
`;

export const Paragraph = styled.p`
  margin-bottom: 8px;
`;

export const ToggleContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: flex-start;
`;

export const StyledToggle = styled(ToggleButton)`
  margin-right: 8px;
`;

export const ActionStrip = styled.div`
  border-top: 1px solid ${COLORS.tertiary};
  padding: 12px;
`;

export const ActionButton = styled(Button)`
  margin-right: 8px;
`;

export const StyledRefreshIcon = styled(RefreshIcon)`
  margin-right: 4px;
`;

export const StyledPlayIcon = styled(PlayIcon)`
  margin-right: 4px;
`;

export const LastRefreshSpan = styled.span`
  margin-left: 4px;
`;
